<template>
  <CompanyAttorneyForm ref="companyAttorneyForm" title="Добавить доверенность" @submit="onSubmit" @cancel="onCancel"/>
</template>
<script>
import CompanyAttorneyForm from "./CompanyAttorneyForm";
import AttorneyService from '@/services/attorney.service';
import moment from 'moment';

export default {
  name: 'AddCompanyAttorneyForm',
  components: {
    CompanyAttorneyForm
  },
  methods: {
    onSubmit() {
      let vm = this;
      let formData = vm.$refs.companyAttorneyForm.getFormData();
      AttorneyService.createAttorney(
          {
            Number: formData.number,
            Start: moment(formData.startDate, 'YYYY-MM-DD'),
            End: moment(formData.endDate, 'YYYY-MM-DD'),

            Position: formData.position,
            Fullname: formData.fullName,
            PersonInn: formData.personInn,

            PassportSerial: formData.passportSerial,
            PassportNumber: formData.passportNumber,
            PassportIssuer: formData.passportIssuer,
            PassportIssuedOn: moment(formData.passportIssuedOn, 'YYYY-MM-DD'),

            ContractorInn: formData.contractorInn,
            ContractorName: formData.contractorName,
            ContractNumber: formData.contractNumber,
            ContractDate: formData.contractDate ? moment(formData.contractDate, 'YYYY-MM-DD') : null,

            Items: formData.items
          },
          false
      ).then(function () {
        vm.$refs.companyAttorneyForm.hideLoading();
      })
    },
    clear() {
      this.$refs.companyAttorneyForm.clear();
    },
    onCancel() {
      this.$emit("cancel");
    }
  }
}
</script>